module.exports = __webpack_public_path__ + "img/translationeditor_4.b33b8b81.jpg";